import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { StateService } from "../../services/state.service";
import { VotingStatic } from "../../main-container/pho/voting/voting";
import { UIChart } from "primeng/chart";
import { toTitleCase } from "./../../utils";

@Component({
  selector: "app-sku-details",
  templateUrl: "./sku-details.component.html",
  styleUrl: "./sku-details.component.scss",
})
export class SkuDetailsComponent {
  @Input() showSkuDetailsDialog: boolean = false;
  @Input() skuDetails!: any;
  @Output() onCloseDialog = new EventEmitter<any>();
  @Output() dropDownChange = new EventEmitter<any>();
  @Output() updateOverallSimulation = new EventEmitter<any>();
  @ViewChild("macoSegmentChart") macoSegmentChart!: UIChart;
  @ViewChild("revenueVolumeChart") revenueVolumeChart!: UIChart;
  @Input() dataFrom!: string;
  @Input() withFinancialImpact!: any;
  @Input() skuFeatures: any;
  @Input() previousAnalysis: any;
  @Input() withPreviousAnalysis?: any;
  @Input() analysisTableColumns: any;
  @Input() showTableLoader: any;
  @Input() countryTableData: any = [];
  @Input() regionTableData: any = [];
  @Input() stateTableData: any = [];
  @Input() channelTableData: any = [];
  @Input() overallLevelSKU: any = null;
  @Input() lockAssortment: boolean = false;
  [key: string]: any; // Index signature
  macoLineChartOptions!: any;
  revenueLineChartOptions!: any;
  macoLineChartData!: any;
  revenueLineChartData!: any;
  votingStatic = VotingStatic;
  legendMacoSegmentChart: any[] = [];
  legendRevenueVolumeChart: any[] = [];
  dataFromComponent: any;
  modelOutput: any;

  items = [
    { name: "Last Analysis Output", value: null },
    { name: "Plan of Action", value: null },
    { name: "Action Owner", value: null },
    { name: "Remarks", value: null },
    { name: "Target Date", value: null },
  ];

  previousAnalysisData: any;
  isPreviousAnalysisEmpty: boolean = false;

  experimentDetails: any = [];
  granularityLevel: any[] = [];
  levelsList: any[] = [];
  clusterLevelDict: { [key: string]: any[] } = {};

  subLevelsList: any = [];

  regionClusterList: any;
  channelClusterList: any;
  stateClusterList: any;

  selectedValue: any;

  skuDetailsByLevel: { [key: string]: any[] } = {
    country: [],
    state: [],
    region: [],
    channel: [],
  };

  skuDetailsByClusterName: { [key: string]: any[] } = {
    state: [],
    region: [],
    channel: [],
  };
  nestingAnalysisTableColumns = [
    {
      label: "SKU Name",
      value: "sku_name",
    },
    {
      label: "Volume",
      value: "volume",
    },
    {
      label: "MACO",
      value: "maco",
    },
    {
      label: "Final Recommend",
      value: "final_recommendation",
    },
  ];
  constructor(
    private stateService: StateService,
    public cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.dataFromComponent = this.dataFrom;
    this.revenueLineChartOptions = this.votingStatic.revenueLineChartOptions;
    this.macoLineChartOptions = this.votingStatic.macoLineChartOptions;
    this.macoLineChartData = this.votingStatic.macoLineChartData;
    this.revenueLineChartData = this.votingStatic.revenueLineChartData;
    let expDetails = sessionStorage.getItem("expDetails") || "";
    this.experimentDetails = JSON.parse(expDetails);
    this.selectedValue =
      this.subLevelsList.length > 0 ? this.subLevelsList[1].value : null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["skuDetails"]) {
      const uniqueClusterNames = new Set(
        this.skuDetails?.map((item: any) => item?.cluster_level)
      );
      [...uniqueClusterNames].forEach((value: any) => {
        const key = value.charAt(0).toUpperCase() + value.slice(1);
        this.levelsList.push({ label: key, value: key });
        this.clusterLevelDict[key] = key;
      });

      this.filterDataByClusterLevel();

      setTimeout(() => {
        if (this.withPreviousAnalysis) {
          this.modelOutput = this.previousAnalysis[0]?.model_output;
          this.calculatePreviousAnalysis(this.previousAnalysis);
        }
        this.setLineChartData(this.skuDetails);
      }, 10);
    }
    if (changes["countryTableData"]) {
      this.countryTableData = changes.countryTableData.currentValue;
    }
    if (changes["regionTableData"]) {
      this.regionTableData = changes.regionTableData.currentValue;
    }
    if (changes["channelTableData"]) {
      this.channelTableData = changes.channelTableData.currentValue;
    }
    if (changes["stateTableData"]) {
      this.stateTableData = changes.stateTableData.currentValue;
    }
    if (changes["overallLevelSKU"]) {
      this.overallLevelSKU = changes.overallLevelSKU.currentValue;
    }
  }
  getValue(key: any) {
    if (this.dataFrom == "simulation") {
      return this.overallLevelSKU[key];
    } else {
      return this.skuDetails[key];
    }
  }

  calculatePreviousAnalysis(previousAnalysis: any) {
    if (!previousAnalysis || previousAnalysis.length === 0) {
      return;
    }

    const data = previousAnalysis[0];

    this.items = this.items.map((item) => {
      switch (item.name) {
        case "Last Analysis Output":
          return { ...item, value: data?.final_verdict };
        case "Plan of Action":
          return { ...item, value: data?.plan_of_action };
        case "Action Owner":
          return { ...item, value: (data?.owner).join(", ") };
        case "Remarks":
          return { ...item, value: data?.final_remarks };
        case "Target Date":
          return { ...item, value: this.formatDate(data?.tentative_date) };
        default:
          return item;
      }
    });
    this.selectedValue = this.subLevelsList[0]?.value;
  }

  setLineChartData(selectedSku: any) {
    // updating maco line chart data
    this.macoLineChartData.labels = selectedSku?.sku_trend?.maco_charts?.labels;
    selectedSku?.sku_trend?.maco_charts?.data?.forEach((each: any) => {
      this.macoLineChartData.datasets.forEach((each1: any, index: any) => {
        if (each.name === each1.keyValue) {
          this.macoLineChartData.datasets[index].data = each.values;
        }
      });
    });
    if (this.dataFrom === "simulation") {
      this.macoLineChartData.datasets[1].label =
        toTitleCase(selectedSku.cluster_name) + " MACO Margin";
      this.macoLineChartData.datasets[2].label =
        toTitleCase(selectedSku.ptc_segment) + " MACO Margin";
    }
    this.macoLineChartData = { ...this.macoLineChartData };

    // updating revenue, volume line chart data
    this.revenueLineChartData.labels =
      selectedSku?.sku_trend?.volume_charts?.labels;
    selectedSku?.sku_trend?.volume_charts?.data?.forEach((each: any) => {
      this.revenueLineChartData.datasets.forEach((each1: any, index: any) => {
        if (each.name === each1.keyValue) {
          this.revenueLineChartData.datasets[index].data = each.values;
        }
      });
    });

    this.revenueLineChartData.labels =
      selectedSku?.sku_trend?.volume_charts?.labels;

    let colors = ["#355070", "#E0842F"];

    this.revenueLineChartData.datasets =
      selectedSku?.sku_trend?.volume_charts?.data.map(
        (each: any, index: number) => ({
          keyValue: each.name,
          label: each.name,
          fill: false,
          borderColor: colors[index % colors.length],
          yAxisID: "y",
          tension: 0,
          borderWidth: 1,
          data: each.values,
        })
      );

    this.revenueLineChartData = { ...this.revenueLineChartData };

    this.updateLegendMacoSegmentChart(this.macoLineChartData);
    this.updateLegendRevenueVolumeChart(this.revenueLineChartData);
    this.nestingAnalysisTableData = selectedSku.nesting_analysis;
    //rounding the decimal values
    this.nestingAnalysisTableData?.forEach((data: any) => {
      data.volume = Number(data.volume).toFixed(0);
      data.maco = Number(data.maco).toFixed(0);
    });
    this.cdr.detectChanges();
  }

  nParseFloat(val: any) {
    if (typeof val == "string") {
      return val != "" ? val : "-";
    } else if (this.isInt(val)) {
      return this.formatNumber(val);
    } else if (val && typeof val != "string" && !this.isInt(val)) {
      const floatVal: any = val.toFixed(1);
      return this.formatNumber(floatVal);
    } else {
      return val || "-";
    }
  }

  isInt(num: any) {
    return Number(num) === num && num % 1 === 0;
  }

  formatNumber(num: number) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  getString(input: any) {
    return String(input);
  }

  // Preparing legend for segment line chart
  updateLegendMacoSegmentChart(chartLabels: any) {
    this.legendMacoSegmentChart = chartLabels?.datasets?.map(
      (dataset: any, index: any) => ({
        label: dataset.label,
        color: dataset.borderColor,
        textHide: true,
      })
    );
  }

  // Preparing legend for segment line chart
  updateLegendRevenueVolumeChart(chartLabels: any) {
    this.legendRevenueVolumeChart = chartLabels?.datasets?.map(
      (dataset: any, index: any) => ({
        label: dataset.label,
        color: dataset.borderColor,
        textHide: true,
      })
    );
  }

  // Function for update the line chart when click the legend items
  onLegendItemClick(index: any, chartIdName: string, legendName: string) {
    const meta = this[chartIdName].chart.getDatasetMeta(index);
    meta.hidden = !meta.hidden;
    this[legendName][index]["textHide"] = !meta.hidden;
    this[chartIdName].chart.update();
  }

  closeDialog() {
    this.showSkuDetailsDialog = false;
    this.onCloseDialog.emit(this.showSkuDetailsDialog);
  }
  getKeyValue(item: any) {
    let selectedSKU =
      this.dataFrom == "simulation" ? this.overallLevelSKU : this.skuDetails;
    if (selectedSKU && selectedSKU[item.key] !== undefined) {
      // Proceed if skuDetails and item.key exist
      return item.formatNumber
        ? this.formatNumber(
            this.nParseFloat(
              item.fixed
                ? selectedSKU[item.key].toFixed(0)
                : selectedSKU[item.key]
            )
          )
        : this.nParseFloat(
            item.fixed
              ? selectedSKU[item.key].toFixed(0)
              : selectedSKU[item.key]
          );
    } else {
      return 0; // Return 0 if skuDetails or the key is missing
    }
  }

  formatDate(dateString: any) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    // Determine the ordinal suffix for the day using a lookup table
    const suffixes = [
      "th",
      "st",
      "nd",
      "rd",
      "th",
      "th",
      "th",
      "th",
      "th",
      "th",
    ];
    const suffix =
      day % 10 >= 1 && day % 10 <= 3 && !(day >= 11 && day <= 13)
        ? suffixes[day % 10]
        : suffixes[0];

    return `${day}${suffix} ${month} ${year}`;
  }

  getClass(output: string): string {
    if (output === "Keep") {
      return "keep-output";
    } else if (output === "Consult") {
      return "consult-output";
    } else if (output === "Delist") {
      return "delist-output";
    }
    return "";
  }

  filterDataByClusterLevel() {
    this.skuDetailsByClusterName = { region: [], state: [], channel: [] };
    this.skuDetailsByLevel = {
      region: [],
      state: [],
      channel: [],
      country: [],
    };

    this.skuDetails.forEach((item: any) => {
      const { cluster_level, cluster_name } = item;

      if (!this.skuDetailsByLevel[cluster_level]) {
        this.skuDetailsByLevel[cluster_level] = [];
      }
      this.skuDetailsByLevel[cluster_level].push(item);

      if (
        cluster_level === "region" &&
        !this.skuDetailsByClusterName.region.includes(cluster_name)
      ) {
        this.skuDetailsByClusterName.region.push(cluster_name);
      } else if (
        cluster_level === "state" &&
        !this.skuDetailsByClusterName.state.includes(cluster_name)
      ) {
        this.skuDetailsByClusterName.state.push(cluster_name);
      } else if (
        cluster_level === "channel" &&
        !this.skuDetailsByClusterName.channel.includes(cluster_name)
      ) {
        this.skuDetailsByClusterName.channel.push(cluster_name);
      }
    });

    this.skuDetailsByClusterName.region = [
      ...new Set(this.skuDetailsByClusterName.region),
    ];
    this.skuDetailsByClusterName.state = [
      ...new Set(this.skuDetailsByClusterName.state),
    ];
    this.skuDetailsByClusterName.channel = [
      ...new Set(this.skuDetailsByClusterName.channel),
    ];

    this.regionClusterList = this.skuDetailsByClusterName.region.map(
      (item: any) => ({
        label: item,
        value: item,
      })
    );

    this.channelClusterList = this.skuDetailsByClusterName.channel.map(
      (item: any) => ({
        label: item,
        value: item,
      })
    );

    this.stateClusterList = this.skuDetailsByClusterName.state.map(
      (item: any) => ({
        label: item,
        value: item,
      })
    );

    this.skuDetails =
      this.skuDetailsByLevel.country && this.skuDetailsByLevel.country.length
        ? this.skuDetailsByLevel.country[0]
        : [];
  }

  onTabChange(event: any) {
    const selectedLevel = this.levelsList[event.index]?.value;
    this.skuDetails =
      this.skuDetailsByLevel?.[selectedLevel.toLowerCase()]?.[0];
    this.setLineChartData(this.skuDetails);
  }

  onSubLevelChange(selectedSubLevel: any, granularityLevel: string) {
    if (granularityLevel === "region") {
      this.skuDetails = this.skuDetailsByLevel.region.filter(
        (value: any) => value.cluster_name == selectedSubLevel
      )[0];
      this.setLineChartData(this.skuDetails);
    }
    if (granularityLevel === "channel") {
      this.skuDetails = this.skuDetailsByLevel.channel.filter(
        (value: any) => value.cluster_name == selectedSubLevel
      )[0];
      this.setLineChartData(this.skuDetails);
    }
    if (granularityLevel === "state") {
      this.skuDetails = this.skuDetailsByLevel.state.filter(
        (value: any) => value.cluster_name == selectedSubLevel
      )[0];
      this.setLineChartData(this.skuDetails);
    }
  }
  setTabChartData(event: any) {
    if (event.originalEvent.target.innerText == "Country") {
      this.skuDetails = this.countryTableData[0];
    }
    if (event.originalEvent.target.innerText == "Region") {
      this.selectedRegionForChartData = this.regionTableData[0]?.cluster_name;
      this.skuDetails = this.regionTableData[0];
    }
    if (event.originalEvent.target.innerText == "State") {
      this.selectedStateForChartData = this.stateTableData[0]?.cluster_name;
      this.skuDetails = this.stateTableData[0];
    }
    if (event.originalEvent.target.innerText == "Channel") {
      this.selectedChannelForChartData = this.channelTableData[0]?.cluster_name;
      this.skuDetails = this.channelTableData[0];
    }
    this.setLineChartData(this.skuDetails);
  }
  getSelectedRowItem(event: any, level: any) {
    console.log(event);
    this.dropDownChange.emit({
      changedLevel: level,
      table: this[`${level}TableData`],
      data: event.data,
    });
  }
  updateSimulation(event: any, selectedResult: any) {
    this.updateOverallSimulation.emit({ result: selectedResult });
  }
}
